module.exports = __webpack_public_path__ + "img/all.076abca3.svg";